import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import { Query, withApollo } from 'react-apollo'
import Select from 'react-select'
import {
  Typography,
  Grid,
  withStyles,
  Divider,
  TextField,
  Button,
  IconButton,
  CircularProgress
} from '@material-ui/core'
import BackIcon from '@material-ui/icons/ArrowBack'
import Loader from '../../common/Loader'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import { EXITED } from 'react-transition-group/Transition'

const GET_OR_EDIT_SUBSCRIPTION = gql`
  mutation(
    $partnerLoginId: Int!
    $billingModeId: Int!
    $billingFrequencyId: Int!
    $mmtc: Int!
    $noOfDevices: Int!
    $subscriptionId: Int
    $salesRemarks: String
  ) {
    createPartnerSubscription(
      partnerLoginId: $partnerLoginId
      billingModeId: $billingModeId
      billingFrequencyId: $billingFrequencyId

      mmtc: $mmtc
      noOfDevices: $noOfDevices
      subscriptionId: $subscriptionId
      salesRemarks: $salesRemarks
    )
  }
`
const CREATE_PARTNER_SUBSCRIPTION = gql`
  mutation createPartnerSubscription(
    $partnerLoginId: Int!
    $billingFrequencyId: Int!
    $GST: Float!
    $deviceModelId: Int!
    $hardwareQty: Int!
    $hardwareCharges: Int!
    $softwareQty: Int!
    $softwareTrackingCharges: Int!
    $serviceProviderId: Int
    $simQty: Int!
    $simCharges: Int!
    $accessoryTypeId: Int
    $accessoryQty: Int!
    $accessoryCharges: Int!
    $salesRemarks: String
  ) {
    createPartnerSubscription(
      partnerLoginId: $partnerLoginId
      billingFrequencyId: $billingFrequencyId
      GST: $GST
      deviceModelId: $deviceModelId
      hardwareQty: $hardwareQty
      hardwareCharges: $hardwareCharges
      softwareQty: $softwareQty
      softwareTrackingCharges: $softwareTrackingCharges
      serviceProviderId: $serviceProviderId
      simQty: $simQty
      simCharges: $simCharges
      accessoryTypeId: $accessoryTypeId
      accessoryQty: $accessoryQty
      accessoryCharges: $accessoryCharges
      salesRemarks: $salesRemarks
    )
  }
`
const GET_PARTNER_DETAILS = gql`
  query partnerDetail($loginId: Int) {
    partnerDetail(loginId: $loginId) {
      id
      billingMode {
        id
        billingMode
      }
    }
  }
`

const GET_BILLING_FREQUENCIES = gql`
  query getAllBillingFrequency($billingModeId: Int!) {
    billingFrequencies: getAllBillingFrequency(billingModeId: $billingModeId) {
      id
      frequency
      billingModeId
      numberOfMonths
    }
  }
`
const GET_DEVICE_MODELS = gql`
  query {
    deviceModel: allDeviceModels {
      id
      model_name
    }
  }
`
const GET_ACCESSORY = gql`
  query {
    accessoryDetails: getAllAccessoryTypes {
      id
      accessoryName
    }
  }
`
const GET_SIM_PROVIDER = gql`
  query {
    simDetails: allServiceProviders {
      id
      name
    }
  }
`
const styles = theme => ({
  container: {
    padding: theme.spacing.unit * 2
  },

  formContainer: {
    marginTop: theme.spacing.unit * 2
  },
  selectSytle: {
    width: '80%'
  },

  dropdown: {
    maxWidth: '100%',
    width: 300
  }
})

class SubscriptionForm extends Component {
  constructor(props) {
    super(props)
    this.partnerLoginId = parseInt(this.props.match.params.loginId, 10)
    this.state = {
      billingModeId: null,
      billingFrequencies: null,
      billingFrequency: null,
      deviceModels: null,
      accessoryDetails: null,
      simDetails: null,
      deviceModelId: 0,
      simProviderId: 0,
      accessoryId: 0,
      gstRates: null,
      gstRate: null,
      softwareQuantity: 0,
      softwareTrackingCharges: 0,
      hardwareQuantity: 0,
      hardwareCharges: 0,
      accessoryQuantity: 0,
      accessoryCharges: 0,
      simQuantity: 0,
      simCharges: 0,
      totalAmountSoftware: 0,
      totalAmountHardware: 0,
      totalAmountAccessory: 0,
      totalAmountSim: 0,
      isSaveConfDialogOpen: false,
      isCancelConfDialogOpen: false,
      isSaveBtnDisabled: false,
      salesRemarks: null
      // selectedBillingMode: null,
      // selectedBillingFrequency: null,
      // deviceRate: '',
      // gst: '',
      // totalAmount: '',
      // formSaving: false
    }
  }

  // handleChange = e => {
  //   this.setState(
  //     {
  //       [e.target.name]: e.target.value
  //     },
  //     () => {
  //       if (this.state.deviceQuantity && this.state.deviceRate) {
  //         this.setState(({ deviceQuantity, deviceRate }) => ({
  //           totalAmount: deviceRate * deviceQuantity
  //         }))
  //       } else {
  //         this.setState({ totalAmount: '' })
  //       }
  //     }
  //   )
  // }

  // handleBillingFrequencyChange = billingFrequency => {
  //   this.setState({
  //     selectedBillingFrequency: billingFrequency.value
  //   })
  // }

  // handleBillingModeChange = billingMode => {
  //   this.setState(
  //     {
  //       selectedBillingMode: billingMode.value,
  //       selectedBillingFrequency: null
  //     },
  //     this.fetchBillingFrequencies
  //   )
  // }

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
    this.setState({ isSaveBtnDisabled: false })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveSubscription = async event => {
    // console.log('save', this.state.salesRemarks)
    // console.log(this.state.simModel, 'acc')
    // console.log('inputs=', this.state.accessoryId, this.state.accessoryQuantity)
    this.setState({ isSaveBtnDisabled: true })
    if (
      parseInt(this.state.hardwareQuantity, 10) !==
      parseInt(this.state.softwareQuantity, 10)
    ) {
      this.props.openSnackbar(
        'The Software Quantity and Device Quantity Should Be Equal'
      )
    } else if (this.state.hardwareQuantity < 1) {
      this.props.openSnackbar('Device quantity should be greater than 0')
    } else if (this.state.softwareTrackingCharges < 1) {
      this.props.openSnackbar('Software amount should be greater than 0')
    } else if (
      this.state.deviceModelId === 0 ||
      this.state.deviceModelId === ''
    ) {
      this.props.openSnackbar('Please Select Device Model')
    } else if (
      this.state.simProviderId !== 0 &&
      this.state.simProviderId !== '' &&
      (this.state.simQuantity < 1 ||
        this.state.simQuantity === 0 ||
        this.state.simQuantity === '')
    ) {
      this.props.openSnackbar('Select valid quantity for Sim')
      // } else if (
      //   this.state.simProviderId !== 0 &&
      //   this.state.simProviderId !== '' &&
      //   this.state.simQuantity > 0 &&
      //   (this.state.simCharges < 1 || this.state.simCharges === '')
      // ) {
      //   this.props.openSnackbar('Select valid Price for Sim')
      // }
    } else if (
      this.state.accessoryId !== 0 &&
      this.state.accessoryId !== '' &&
      (this.state.accessoryQuantity < 1 ||
        this.state.accessoryQuantity === 0 ||
        this.state.accessoryQuantity === '')
    ) {
      // console.log('Select valid quantity for Accessory')
      this.props.openSnackbar('Select valid quantity for Accessory')
    } else if (
      (this.state.simProviderId === 0 || this.state.simProviderId === '') &&
      (this.state.simQuantity > 0 ||
        (this.state.simQuantity !== 0 && this.state.simQuantity !== ''))
    ) {
      this.props.openSnackbar('Please Select Sim Provider')
    } else if (
      (this.state.accessoryId === 0 || this.state.accessoryId === '') &&
      (this.state.accessoryQuantity > 0 ||
        (this.state.accessoryQuantity !== 0 &&
          this.state.accessoryQuantity !== ''))
    ) {
      this.props.openSnackbar('Please Select Accessory Model')
    } else {
      const { data } = await this.props.client.mutate({
        mutation: CREATE_PARTNER_SUBSCRIPTION,
        variables: {
          partnerLoginId: this.partnerLoginId,
          billingFrequencyId: parseInt(this.state.billingFrequency, 10),
          GST: parseInt(this.state.gstRate, 10),
          deviceModelId: parseInt(this.state.deviceModelId, 10),
          accessoryTypeId: parseInt(this.state.accessoryId, 10),
          serviceProviderId: parseInt(this.state.simProviderId, 10),
          hardwareQty: parseInt(this.state.hardwareQuantity, 10),
          accessoryQty: parseInt(this.state.accessoryQuantity, 10),
          simQty: parseInt(this.state.simQuantity, 10),
          softwareQty: parseInt(this.state.softwareQuantity, 10),
          softwareTrackingCharges: parseInt(
            this.state.softwareTrackingCharges,
            10
          ),
          simCharges: parseInt(this.state.simCharges, 10),
          hardwareCharges: parseInt(this.state.hardwareCharges, 10),
          accessoryCharges: parseInt(this.state.accessoryCharges, 10),
          salesRemarks: this.state.salesRemarks
        }
      })
      if (data.createPartnerSubscription === true) {
        this.props.openSnackbar('Subscription Creation Successful')
        this.setState({ isSaveConfDialogOpen: false })
        this.props.history.push({
          pathname: '/home/partner/view/' + this.partnerLoginId
        })
      } else {
        this.props.openSnackbar('Subscription Creation Failed')
      }
    }
  }

  handleCancelSubscription = e => {
    // this.setState({
    //   billingMode: null,
    //   billingFrequency: null,
    //   billingFrequencies: null,
    //   totalQuantity: null,
    //   totalAmount: null,
    //   deviceModel: null,
    //   deviceQuantity: null,
    //   accessoryModel: null,
    //   accessoryQuantity: null,
    //   simModel: null,
    //   simQuantity: null,
    //   grandTotalAmount: null,
    //   PIBucketName: null,
    //   PIFileName: null
    // })
    this.props.history.goBack()
  }

  calculateAmount(quantity, charges, productPerticular) {
    let totalAmount = 0

    totalAmount = parseFloat(quantity, 10) * parseFloat(charges, 10)
    console.log('total amount', totalAmount)
    if (
      productPerticular === 'softwareQuantity' ||
      productPerticular === 'softwareTrackingCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountSoftware: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountSoftware: '' })
      }
    }

    if (
      productPerticular === 'hardwareQuantity' ||
      productPerticular === 'hardwareCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountHardware: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountHardware: '' })
      }
    }

    if (
      productPerticular === 'accessoryQuantity' ||
      productPerticular === 'accessoryCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountAccessory: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountAccessory: '' })
      }
    }

    if (
      productPerticular === 'simQuantity' ||
      productPerticular === 'simCharges'
    ) {
      if (!isNaN(totalAmount)) {
        this.setState({ totalAmountSim: Math.round(totalAmount) })
      } else {
        this.setState({ totalAmountSim: '' })
      }
    }
  }

  handleInputChange = name => e => {
    this.setState(
      { [name]: e.target.value }
      // console.log('gfhgf', this.state.salesRemarks)
    )
  }
  handleChange = name => event => {
    if (event.target.value >= 0) {
      this.setState({ [name]: event.target.value }, () => {
        if (name === 'softwareQuantity' || name === 'softwareTrackingCharges') {
          const { softwareQuantity, softwareTrackingCharges } = this.state
          this.calculateAmount(softwareQuantity, softwareTrackingCharges, name)
        }
        if (name === 'hardwareQuantity' || name === 'hardwareCharges') {
          const { hardwareQuantity, hardwareCharges } = this.state
          this.calculateAmount(hardwareQuantity, hardwareCharges, name)
        }
        if (name === 'accessoryQuantity' || name === 'accessoryCharges') {
          const { accessoryQuantity, accessoryCharges } = this.state
          this.calculateAmount(accessoryQuantity, accessoryCharges, name)
        }
        if (name === 'simQuantity' || name === 'simCharges') {
          const { simQuantity, simCharges } = this.state
          this.calculateAmount(simQuantity, simCharges, name)
        }
      })
    } else if (!event.target.value) {
      if (name === 'softwareQuantity' || name === 'softwareTrackingCharges') {
        this.setState({ [name]: null, totalAmountSoftware: null })
      }
      if (name === 'hardwareQuantity' || name === 'hardwareCharges') {
        this.setState({ [name]: null, totalAmountHardware: null })
      }
      if (name === 'accessoryQuantity' || name === 'accessoryCharges') {
        this.setState({ [name]: null, totalAmountAccessory: null })
      }
      if (name === 'simQuantity' || name === 'simCharges') {
        this.setState({ [name]: null, totalAmountSim: null })
      }
    }
  }

  handleSelectChange = name => value => {
    // console.log('hh', [name], value.value)
    if (value) {
      this.setState({ [name]: value.value }, () => {})
    } else {
      this.setState({ [name]: 0 }, () => {})
    }
  }

  handleSubmit = async e => {
    e.preventDefault()
    if (
      this.state.selectedBillingMode === null ||
      this.state.billingFrequency === null ||
      this.state.hardwareQuantity === '' ||
      this.state.deviceRate === '' ||
      this.state.gst === ''
    ) {
      this.props.openSnackbar('Invalid form')
    } else {
      let variables = {
        partnerLoginId: parseInt(this.props.match.params.loginId, 10),
        billingModeId: parseInt(this.state.selectedBillingMode, 10),
        billingFrequencyId: parseInt(this.state.billingFrequency, 10),
        gst: parseFloat(this.state.gst),
        mmtc: parseInt(this.state.deviceRate, 10),
        noOfDevices: parseInt(this.state.hardwareQuantity, 10),
        salesRemarks: this.state.salesRemarks
      }

      if (this.props.location.state.subscriptionDetails) {
        variables.subscriptionId = parseInt(
          this.props.location.state.subscriptionDetails.id,
          10
        )
      }

      this.setState({
        formSaving: true
      })

      const { data } = await this.props.client.mutate({
        mutation: GET_OR_EDIT_SUBSCRIPTION,
        variables
      })

      this.setState({
        formSaving: false
      })

      if (data && data.createPartnerSubscription) {
        if (this.props.location.state.edit) {
          this.props.openSnackbar('Edited subscription successfully')
        } else {
          this.props.openSnackbar('Created subscription successfully')
        }

        this.props.history.goBack()
      } else {
        if (this.props.location.state.edit) {
          this.props.openSnackbar('Subscription edit failed')
        } else {
          this.props.openSnackbar('Subscription creation failed')
        }
      }
    }
  }

  // fetchBillingFrequencies = async billingMode => {
  //   const { data } = await this.props.client.query({
  //     query: GET_BILLING_FREQUENCIES,
  //     variables: {
  //       billingModeId: billingMode || this.state.selectedBillingMode
  //     }
  //   })

  //   return new Promise(resolve => {
  //     this.setState(
  //       {
  //         billingFrequencies: data.billingFrequencies.map(billingFrequency => ({
  //           label: billingFrequency.frequency,
  //           value: billingFrequency.id
  //         }))
  //       },
  //       resolve
  //     )
  //   })
  // }

  fillDetailsForEditMode = async subscriptionDetails => {
    await this.fetchBillingFrequencies(subscriptionDetails.selectedBillingMode)
    this.setState(subscriptionDetails)
  }

  setGstRates = () => {
    const gstRates = [5, 10, 12, 15, 18]
    const billingGst = gstRates.map(gst => ({
      value: gst,
      label: gst
    }))

    this.setState({
      gstRates: billingGst
    })
  }

  getPartnerDetails = async () => {
    const { data } = await this.props.client.query({
      query: GET_PARTNER_DETAILS,
      variables: {
        loginId: this.partnerLoginId
      }
    })

    if (data && data.partnerDetail) {
      const { billingMode } = data.partnerDetail
      // console.log(billingMode.id, 'data')
      this.setState({ billingModeId: billingMode.id }, () => {
        this.getBillingFrequencies()
        this.getDeviceModels()
        this.getAccessoryDetails()
        this.getSimDetails()
      })
    }
  }

  mapBillingFrequencies = billingFrequencies => {
    const mappedBillingFrequency = billingFrequencies.reduce((acc, item) => {
      const billingFrequency = {
        value: item.id,
        label: item.frequency
      }
      acc.push(billingFrequency)
      return acc
    }, [])
    this.setState({ billingFrequencies: mappedBillingFrequency })
  }

  getBillingFrequencies = async () => {
    const { data } = await this.props.client.query({
      query: GET_BILLING_FREQUENCIES,
      variables: {
        billingModeId: this.state.billingModeId
      }
    })
    if (data.billingFrequencies) {
      this.mapBillingFrequencies(data.billingFrequencies)
    }
  }

  getDeviceModels = async () => {
    const { data } = await this.props.client.query({
      query: GET_DEVICE_MODELS
    })
    if (data.deviceModel) {
      const mappedDeviceModels = data.deviceModel.reduce((acc, item) => {
        const deviceModels = {
          value: item.id,
          label: item.model_name
        }
        acc.push(deviceModels)
        return acc
      }, [])

      this.setState({ deviceModels: mappedDeviceModels })
      // console.log('deviceModel', this.state.deviceModels)
    }
  }
  getAccessoryDetails = async () => {
    const { data } = await this.props.client.query({
      query: GET_ACCESSORY
    })
    if (data.accessoryDetails) {
      const mappedaccessoryDetails = data.accessoryDetails.reduce(
        (acc, item) => {
          const accessoryDetails = {
            value: item.id,
            label: item.accessoryName
          }
          acc.push(accessoryDetails)
          return acc
        },
        []
      )

      this.setState({ accessoryDetails: mappedaccessoryDetails })
      // console.log('deviceModel', this.state.accessoryDetails)
    }
  }
  getSimDetails = async () => {
    const { data } = await this.props.client.query({
      query: GET_SIM_PROVIDER
    })
    if (data.simDetails) {
      const mappedSimDetails = data.simDetails.reduce((acc, item) => {
        const SimDetails = {
          value: item.id,
          label: item.name
        }
        acc.push(SimDetails)
        return acc
      }, [])

      this.setState({ simDetails: mappedSimDetails })
      // console.log('deviceModel', this.state.SimDetails)
    }
  }

  componentDidMount() {
    this.getPartnerDetails()
    this.setGstRates()
  }

  render() {
    // console.log('hi')
    const { classes } = this.props
    const {
      billingFrequencies,
      billingFrequency,
      gstRates,
      gstRate,
      softwareQuantity,
      softwareTrackingCharges,
      hardwareQuantity,
      hardwareCharges,
      accessoryQuantity,
      accessoryCharges,
      simQuantity,
      simCharges,
      totalAmountSoftware,
      totalAmountHardware,
      totalAmountAccessory,
      totalAmountSim,
      isSaveConfDialogOpen,
      isCancelConfDialogOpen
    } = this.state
    const formTitle = 'Create Subscription'
    return (
      <Fragment>
        <ConfirmationalDialog
          isDialogOpen={isSaveConfDialogOpen}
          dialogMessage={'Are you sure you want to Save this subscription?'}
          negativeResponseHandler={this.handleSaveNegativeResponse}
          positiveResponseHandler={this.handleSaveSubscription}
          isSaveBtnDisabled={this.state.isSaveBtnDisabled}
        />
        <ConfirmationalDialog
          isDialogOpen={isCancelConfDialogOpen}
          dialogMessage={
            'Are you sure you want to Cancel new subscription creation?'
          }
          negativeResponseHandler={this.handleCancelNegativeResponse}
          positiveResponseHandler={this.handleCancelSubscription}
        />
        <Grid container className={classes.container}>
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <Grid item>
                <IconButton onClick={this.props.history.goBack}>
                  <BackIcon />
                </IconButton>
              </Grid>

              <Grid item>
                <Typography variant="title">{formTitle}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <br />

          {/*  Subscription Add Details */}
          <Grid item xs={12}>
            <Grid container spacing={16}>
              <Grid item xs={12}>
                <Grid container alignItems="baseline" justify="space-around">
                  {billingFrequencies && (
                    <Grid item xs={12} sm={3}>
                      <Select
                        className={classes.selectSytle}
                        options={billingFrequencies}
                        value={billingFrequency}
                        onChange={this.handleSelectChange('billingFrequency')}
                        placeholder="Billing Frequency *"
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={3}>
                    <Select
                      className={classes.selectSytle}
                      options={gstRates}
                      value={gstRate}
                      onChange={this.handleSelectChange('gstRate')}
                      placeholder="Select GST Rate *"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      id="salesRemarks"
                      label="Sales Remarks"
                      value={this.state.salesRemarks}
                      name="salesRemarks"
                      onChange={this.handleInputChange('salesRemarks')}
                      margin="none"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Software Row */}
              <Grid item xs={12}>
                <Grid container alignItems="baseline" spacing={8}>
                  <Grid item xs={12}>
                    <Typography variant="body1">Software</Typography>
                  </Grid>
                  <Grid container justify="flex-start" alignItems="flex-end">
                    <Grid item xs={12} sm={3}>
                      <TextField disabled label="AquilaTrack Software" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="softwareQuantity"
                        label="Software Quantity *"
                        value={softwareQuantity}
                        onChange={this.handleChange('softwareQuantity')}
                        type="number"
                        inputProps={{ min: 0 }}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="softwareTrackingCharges"
                        type="number"
                        label="Software Charges *"
                        value={softwareTrackingCharges}
                        onChange={this.handleChange('softwareTrackingCharges')}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">
                        Total Amount per month (excl GST): &nbsp;
                      </Typography>
                      <Typography variant="body2">
                        &#8377; {console.log(totalAmountSoftware)}
                        {isNaN(parseInt(totalAmountSoftware, 10))
                          ? '-'
                          : totalAmountSoftware}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Device Row */}
              <Grid item xs={12}>
                <Grid container alignItems="baseline" spacing={8}>
                  <Grid item xs={12}>
                    <Typography variant="body1">Devices</Typography>
                  </Grid>
                  <Grid container justify="flex-start" alignItems="flex-end">
                    {/* <Grid item xs={12} sm={3}>
                      <TextField disabled label="AquilaTrack Hardware" />
                    </Grid> */}
                    <Grid item xs={12} sm={3}>
                      <Select
                        className={classes.selectSytle}
                        options={this.state.deviceModels}
                        value={this.state.deviceModelId}
                        onChange={this.handleSelectChange('deviceModelId')}
                        placeholder="Select Model *"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="quantity"
                        label="Device Quantity *"
                        value={hardwareQuantity}
                        onChange={this.handleChange('hardwareQuantity')}
                        type="number"
                        inputProps={{ min: 0 }}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="hardwareCharges"
                        type="number"
                        label="Hardware Charges *"
                        value={hardwareCharges}
                        onChange={this.handleChange('hardwareCharges')}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">
                        Total Amount per month (excl GST): &nbsp;
                      </Typography>
                      <Typography variant="body2">
                        &#8377;{' '}
                        {isNaN(parseInt(totalAmountHardware, 10))
                          ? '-'
                          : totalAmountHardware}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Accessories Row */}
              <Grid item xs={12}>
                <Grid container alignItems="baseline" spacing={8}>
                  <Grid item xs={12}>
                    <Typography variant="body1">Accessories</Typography>
                  </Grid>
                  <Grid container justify="flex-start" alignItems="flex-end">
                    {/* <Grid item xs={12} sm={3}>
                      <TextField disabled label="AquilaTrack Accessory" />
                    </Grid> */}
                    <Grid item xs={12} sm={3}>
                      <Select
                        className={classes.selectSytle}
                        options={this.state.accessoryDetails}
                        value={this.state.accessoryId}
                        onChange={this.handleSelectChange('accessoryId')}
                        placeholder="Select Type"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="accessoryQuantity"
                        label="Quantity"
                        value={accessoryQuantity}
                        onChange={this.handleChange('accessoryQuantity')}
                        type="number"
                        inputProps={{ min: 0 }}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        id="accessoryCharges"
                        label="Accessory Charges"
                        type="number"
                        value={accessoryCharges}
                        onChange={this.handleChange('accessoryCharges')}
                        margin="none"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography variant="body1">
                        Total Amount per month (excl GST): &nbsp;
                      </Typography>
                      <Typography variant="body2">
                        &#8377;{' '}
                        {isNaN(parseInt(totalAmountAccessory, 10))
                          ? '-'
                          : totalAmountAccessory}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Sims Row */}
              <Grid item xs={12}>
                <Grid container alignItems="baseline" spacing={8}>
                  <Grid item xs={12}>
                    <Typography variant="body1">SIM Cards</Typography>
                  </Grid>
                  {/* <Grid item xs={12} sm={3}>
                    <TextField disabled label="AquilaTrack Sim" />
                  </Grid> */}
                  <Grid item xs={12} sm={3}>
                    <Select
                      className={classes.selectSytle}
                      options={this.state.simDetails}
                      value={this.state.simProviderId}
                      onChange={this.handleSelectChange('simProviderId')}
                      placeholder="Select Provider"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      id="simQuantity"
                      label="Quantity"
                      value={simQuantity}
                      onChange={this.handleChange('simQuantity')}
                      type="number"
                      inputProps={{ min: 0 }}
                      margin="none"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      id="simCharges"
                      type="number"
                      label="Annual Sim Charges"
                      value={simCharges}
                      onChange={this.handleChange('simCharges')}
                      margin="none"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="body1">
                      Total Amount per month (excl GST): &nbsp;
                    </Typography>
                    <Typography variant="body2">
                      &#8377;{' '}
                      {isNaN(parseInt(totalAmountSim, 10))
                        ? '-'
                        : totalAmountSim}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Action items */}
              <Grid item>
                {console.log(
                  'button calue---',
                  parseInt(softwareTrackingCharges, 10) === 0 ||
                    softwareQuantity === 0 ||
                    hardwareCharges === '' ||
                    hardwareCharges === null ||
                    hardwareQuantity === 0 ||
                    hardwareQuantity === '' ||
                    gstRate === null ||
                    gstRate === '' ||
                    billingFrequency === null ||
                    billingFrequency === '' ||
                    accessoryCharges === '' ||
                    accessoryCharges === null ||
                    parseInt(softwareQuantity, 10) !==
                      parseInt(hardwareQuantity, 10)
                )}
                <Button
                  color="secondary"
                  variant="raised"
                  onClick={this.handleSaveClick}
                  disabled={
                    parseInt(softwareTrackingCharges, 10) === 0 ||
                    softwareQuantity === 0 ||
                    hardwareCharges === '' ||
                    hardwareCharges === null ||
                    hardwareQuantity === 0 ||
                    hardwareQuantity === '' ||
                    gstRate === null ||
                    gstRate === '' ||
                    billingFrequency === null ||
                    billingFrequency === '' ||
                    accessoryCharges === '' ||
                    accessoryCharges === null ||
                    parseInt(softwareQuantity, 10) !==
                      parseInt(hardwareQuantity, 10)
                  }
                  // disabled={this.state.isSaveBtnDisabled}
                >
                  Save
                </Button>

                <Button color="secondary" onClick={this.handleCancelClick}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}

// export default

// const WrappedSubscriptionForm = withStyles(styles)(
//   withSharedSnackbar(withApollo(SubscriptionForm))
// )

export default withStyles(styles)(
  withSharedSnackbar(withApollo(SubscriptionForm))
)

// #region

// withRouter(props => {
//   return (
//     <Query query={GET_BILLING_MODES}>
//       {({ loading, error, data, client }) => {
//         if (loading) return <Loader fullscreen={true} />
//         if (error) {
//           return <Typography>Error Loading subscription form</Typography>
//         }

//         return (
//           <WrappedSubscriptionForm
//             {...props}
//             client={client}
//             billingModes={data.billingModes.map(billingMode => ({
//               label: billingMode.billingMode,
//               value: billingMode.id
//             }))}
//           />
//         )
//       }}
//     </Query>
//   )
// })
// #endregion



// WEBPACK FOOTER //
// ./src/components/Pages/Partner/SubscriptionForm.jsx